module.exports = __webpack_public_path__ + "fonts/435b9c7.otf";